import { PlayerDto } from '../Dtos/PlayerDto';

export class GetPlayerRequest {
    static Message = 'GetPlayerRequest';

    public gameId: string;
    public playerId: string;

    constructor(gameId: string, playerId: string) {
        this.gameId = gameId;
        this.playerId = playerId;
    }
}

export class GetPlayerResponse {
    static Message = 'GetPlayerResponse';

    public player: PlayerDto;

    constructor(player: PlayerDto) {
        this.player = player;
    }
}
